/* eslint-disable @typescript-eslint/no-explicit-any */
import { PurchaseAPI } from '../constants/apiURL';
import {
  BettingQrCodeInfo,
  CateringQrCodeInfo
} from '../models/entites/session-storage/qrCodeInfo';

export class QRCodeHelper {
  static GetPurchasApiURLForModule(Modul: any): string {
    switch (Modul) {
      case '1': {
        return PurchaseAPI.CATERING_PURCHASE;
      }
      case 'betting_dual': {
        return PurchaseAPI.BETTING_PURCHASE;
      }
    }
    return '';
  }

  static GenerateQRCodeInfoBasedOnUrlParams(params: any, url: any) {
    const moduleName = params.get('modul');

    if (moduleName == '1') {
      return new CateringQrCodeInfo(params.get('pfr'), params.get('modul'), params.get('time'));
    } else if (moduleName == 'betting_dual') {
      let marketUrl = url;
      const parsed = new URL(url);
      marketUrl = parsed.origin;

      return new BettingQrCodeInfo(
        params.get('idtiket'),
        params.get('modul'),
        params.get('idlokacije'),
        params.get('idkasa'),
        params.get('uplata'),
        params.get('kvota') !== null || params.get('kvota') === undefined
          ? params.get('kvota')
          : params.get('maxkvota'),
        params.get('kvote'),
        params.get('type'),
        params.get('brparova'),
        params.get('time'),
        marketUrl
      );
    }
    return null;
  }

  static GenerateQrCodeBasedOnQrCodeInfo(qrCodeInfo: any, clientId: string) {
    let qrCode;
    if (qrCodeInfo.modul == '1') {
      qrCode = {
        Modul: qrCodeInfo.modul,
        ClientID: clientId,
        PFRId: qrCodeInfo.pfr,
        TransactionTime: this.getTransactionTime(qrCodeInfo.time)
      };
    } else if (qrCodeInfo.modul == 'betting_dual') {
      qrCode = {
        Modul: qrCodeInfo.modul,
        Client_ID: clientId,
        TicketNumber: qrCodeInfo.idtiket,
        Location_ID: qrCodeInfo.idlokacije,
        CashRegister_ID: qrCodeInfo.idkasa,
        Deposit: qrCodeInfo.uplata,
        Quota: qrCodeInfo.kvota,
        Quotes: qrCodeInfo.kvote,
        Type: qrCodeInfo.type,
        NumberOfGames: qrCodeInfo.brparova,
        CreatedDateTime: this.getTicketTime(qrCodeInfo.time),
        MarketUrl: qrCodeInfo.marketUrl
      };
    }
    return qrCode;
  }

  private static getTicketTime(miliseconds: number) {
    const milisecondsNumber = Number(miliseconds);
    const date = new Date(milisecondsNumber);
    return this.getTimeStringFromDate(date);
  }

  private static getTransactionTime(timeTicks: number) {
    const timeTicksNumber = Number(timeTicks);
    const date = new Date(timeTicksNumber * 1000);
    return this.getTimeStringFromDate(date);
  }

  private static getTimeStringFromDate(date: Date) {
    const years = date.getFullYear().toString();
    const months = (date.getMonth() + 1).toString().padStart(2, '0');
    const days = date.getDate().toString().padStart(2, '0');

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return years + '-' + months + '-' + days + ' ' + hours + ':' + minutes + ':' + seconds;
  }
}
